export const GENERATED_IMAGE_RETENTION_DAYS = 14;
export const PAID_ORDER_SUPPORT_RETENTION_DAYS = 90;

export const GENERATED_IMAGE_RETENTION_COPY =
  `Création disponible pendant ${GENERATED_IMAGE_RETENTION_DAYS} jours si elle n'est pas commandée. ` +
  "Commandez ou téléchargez-la pour la conserver.";

export const PAID_ORDER_RETENTION_COPY =
  `Après paiement, l'image de commande est conservée jusqu'à ${PAID_ORDER_SUPPORT_RETENTION_DAYS} jours pour le suivi et le SAV.`;
